module.exports = __webpack_public_path__ + "static/media/kite.4e80b272.svg";